export default __webpack_public_path__ + "static/media/logo.2cdcbb28.png";